import { openModal } from '@core/components/ModalStack';
import { TaskDetailModalProps } from './TaskDetailModal';

export async function openTaskOverlay(props: TaskDetailModalProps) {
  const { TaskDetailModal } = await import('./TaskDetailModal');

  openModal(TaskDetailModal, props);
}
